<button class="btn btn-outline-primary" (click)="logout()">
  Sign out <i class="fa fa-lg fa-sign-out"></i>
</button>

<ch-sidenav-btn></ch-sidenav-btn>
